import { useEffect, useState, useCallback } from 'react';
import { Loading } from './PokladnaUi';
import { fmtKc } from './PokladnaPrehledTab';

export default function PokladnaReportyTab({ cardStyle, isDark, refreshKey }) {
    const [obdobi, setObdobi] = useState({
        od: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
        do: new Date().toISOString().slice(0, 10),
    });
    const [dysky, setDysky] = useState([]);
    const [manka, setManka] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(() => {
        setLoading(true);
        const qs = new URLSearchParams(obdobi);
        Promise.all([
            fetch('/api/finance/pokladna/reporty/dysky?' + qs, { credentials: 'same-origin' }).then(r => r.json()),
            fetch('/api/finance/pokladna/reporty/manka?' + qs, { credentials: 'same-origin' }).then(r => r.json()),
        ]).then(([d, m]) => { setDysky(d); setManka(m); }).catch(console.error).finally(() => setLoading(false));
    }, [obdobi]);
    useEffect(() => { load(); }, [load, refreshKey]);

    return (
        <div className="space-y-4">
            {/* Filtr období */}
            <div className="flex items-end gap-2 rounded-2xl p-3" style={cardStyle}>
                <div className="flex flex-col">
                    <label className="text-xs mb-1" style={{ color: 'var(--text-tertiary)' }}>Od</label>
                    <input type="date" value={obdobi.od} onChange={e => setObdobi(o => ({ ...o, od: e.target.value }))}
                        className="rounded px-2 py-1 text-sm" style={{ ...cardStyle, color: 'var(--text-primary)' }} />
                </div>
                <div className="flex flex-col">
                    <label className="text-xs mb-1" style={{ color: 'var(--text-tertiary)' }}>Do</label>
                    <input type="date" value={obdobi.do} onChange={e => setObdobi(o => ({ ...o, do: e.target.value }))}
                        className="rounded px-2 py-1 text-sm" style={{ ...cardStyle, color: 'var(--text-primary)' }} />
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Dýška per rozvozce */}
                <div className="rounded-2xl p-4" style={cardStyle}>
                    <h3 className="text-sm font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>Dýška per rozvozce (období)</h3>
                    {loading ? <Loading /> : (
                        <table className="w-full text-xs">
                            <thead><tr className="text-[10.5px] font-bold uppercase tracking-wide" style={{ color: 'var(--text-tertiary)', textAlign: 'left' }}>
                                <th className="py-1">Rozvozce</th><th>Smen</th>
                                <th className="text-right">Hot.</th><th className="text-right">Karta</th><th className="text-right">Online</th><th className="text-right">Σ</th>
                            </tr></thead>
                            <tbody>
                                {dysky.length === 0 && <tr><td colSpan={6} className="py-3 text-center" style={{ color: 'var(--text-tertiary)' }}>—</td></tr>}
                                {dysky.map(d => {
                                    const tot = Number(d.dysky_hotovost_kc) + Number(d.dysky_karta_kc) + Number(d.dysky_online_kc);
                                    return (
                                        <tr key={d.zamestnanec_id} style={{ borderTop: '1px solid var(--border-default)', color: 'var(--text-primary)' }}>
                                            <td className="py-1.5">{d.jmeno}</td>
                                            <td>{d.pocet_smen}</td>
                                            <td className="text-right">{fmtKc(d.dysky_hotovost_kc)}</td>
                                            <td className="text-right">{fmtKc(d.dysky_karta_kc)}</td>
                                            <td className="text-right">{fmtKc(d.dysky_online_kc)}</td>
                                            <td className="text-right font-bold" style={{ color: '#06b6d4' }}>{fmtKc(tot)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>

                {/* Manka */}
                <div className="rounded-2xl p-4" style={cardStyle}>
                    <h3 className="text-sm font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>Manka/přebytky (období)</h3>
                    {loading ? <Loading /> : (
                        <table className="w-full text-xs">
                            <thead><tr className="text-[10.5px] font-bold uppercase tracking-wide" style={{ color: 'var(--text-tertiary)', textAlign: 'left' }}>
                                <th className="py-1">Datum</th><th>Rozvozce</th>
                                <th className="text-right">Manko/přebytek</th><th>Řešení</th>
                            </tr></thead>
                            <tbody>
                                {manka.length === 0 && <tr><td colSpan={4} className="py-3 text-center" style={{ color: 'var(--text-tertiary)' }}>—</td></tr>}
                                {manka.map(s => {
                                    const r = Number(s.manko_prebytek_kc);
                                    return (
                                        <tr key={s.id} style={{ borderTop: '1px solid var(--border-default)', color: 'var(--text-primary)' }}>
                                            <td className="py-1.5">{s.datum}</td>
                                            <td>{s.zamestnanec ? `${s.zamestnanec.jmeno} ${s.zamestnanec.prijmeni}` : '—'}</td>
                                            <td className="text-right font-medium" style={{ color: r < 0 ? '#ef4444' : '#10b981' }}>{fmtKc(r)}</td>
                                            <td><span className="text-xs px-1.5 py-0.5 rounded" style={{ background: 'var(--surface-base)' }}>{s.reseni_manka ?? '—'}</span></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
